import { useLayoutEffect } from 'react';

import { useGlobalLoader } from '@/providers/GlobalLoaderProvider';

export const useGlobalLoaderGate = (key: string, isLoading: boolean, message?: string) => {
  const { showLoader, hideLoader } = useGlobalLoader();

  useLayoutEffect(() => {
    if (isLoading) {
      showLoader(key, message);
      return () => {
        hideLoader(key);
      };
    }
    hideLoader(key);
  }, [hideLoader, isLoading, key, message, showLoader]);
};
